export default class initMap {
  constructor() {
    const mapCanvas = document.getElementById('js-mapCanvas');

    if (mapCanvas) {
      google.maps.event.addDomListener(window, 'load', initialize);
    }

    function initialize() {
      var mapCenter = new google.maps.LatLng(35.646056,139.7526741);
      var position = new google.maps.LatLng(35.645063,139.7526741);
      var myOptions = {
        zoom: 16,
        center: mapCenter,
        disableDefaultUI: true,
        mapTypeControlOptions: {
          mapTypeIds: ['map', google.maps.MapTypeId.ROADMAP]
        }
      };
      var map = new google.maps.Map(mapCanvas, myOptions);
      var iconPath = $('#js-mapCanvas').attr('data-pin');

      var icon = new google.maps.MarkerImage(
        iconPath,
        new google.maps.Size(100, 110),
        new google.maps.Point(0, 0),
        new google.maps.Point(52, 110),
      );
      var markerOptions = {
        position: position,
        map: map,
        icon: icon,
        title: 'Brave group'
      };
      var marker = new google.maps.Marker(markerOptions);

      var styleOptions = [
        {
          "elementType": "geometry",
          "stylers": [{
            "color": "#f5f5f5"
          }]
        },{
          "elementType": "labels.icon",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#616161"
          }]
        },{
          "elementType": "labels.text.stroke",
          "stylers": [{
            "color": "#f5f5f5"
          }]
        },{
          "featureType": "administrative.land_parcel",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#bdbdbd"
          }]
        },{
          "featureType": "administrative.neighborhood",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [{
            "color": "#eeeeee"
          }]
        },{
          "featureType": "poi",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#757575"
          }]
        },{
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [{
            "color": "#e5e5e5"
          }]
        },{
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        },{
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "color": "#ffffff"
          }]
        },{
          "featureType": "road",
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#757575"
          }]
        },{
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [{
            "color": "#dadada"
          }]
        },{
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#616161"
          }]
        },{
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        },{
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [{
            "color": "#e5e5e5"
          }]
        },{
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [{
            "color": "#eeeeee"
          }]
        },{
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "color": "#c9c9c9"
          }]
        },{
          "featureType": "water",
          "elementType": "labels.text",
          "stylers": [{
            "visibility": "off"
          }]
        },{
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#9e9e9e"
          }]
        }
      ];

      var styledMapOptions = { name: 'Brave group' }
      var sampleType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
      map.mapTypes.set('map', sampleType);
      map.setMapTypeId('map');
    }
  }
}
